import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton, SecondaryButton } from "../../../components/UIkit";

import { push } from "connected-react-router";
import { getDepartments } from "../../../reducks/department/selectors";
import {
  fetchdepartments,
  saveDepartments,
} from "../../../reducks/department/operations";
import SetDepartmentsArea from "../../../components/master/SetDepartmentsArea";
import { getBases } from "../../../reducks/base/selectors";
import { fetchbases } from "../../../reducks/base/operations";

const OrderingDepartmentEdit = () => {
  const dispatch = useDispatch();
  const departmentsOnFirestore = useSelector(getDepartments);
  const basesOnFirestore = useSelector(getBases);
  const [departments, setDepartments] = useState(departmentsOnFirestore);
  const [bases, setBases] = useState(basesOnFirestore);
  const transition = useCallback(
    (path) => {
      dispatch(push(path));
    },
    [dispatch]
  );
  // コンポーネントが初めてマウントされたときにbasesを取得
  useEffect(() => {
    dispatch(fetchdepartments());
    dispatch(fetchbases());
  }, [dispatch]);
  useEffect(() => {
    setDepartments(departmentsOnFirestore);
  }, [departmentsOnFirestore]);
  useEffect(() => {
    setBases(basesOnFirestore);
  }, [basesOnFirestore]);

  return (
    <section>
      <h2 className="u-text__headline u-text-center">部署の登録・編集</h2>
      <div className="c-section-container">
        {/* <SetBasesArea bases={bases} setBases={setBases} /> */}
        <SetDepartmentsArea
          departments={departments}
          setDepartments={setDepartments}
          bases={bases}
        />
      </div>
      <div className="module-spacer--small" />
      <div className="center">
        <PrimaryButton
          label={"上書き保存"}
          onClick={() => dispatch(saveDepartments(departments))}
        />
      </div>
      <div className="center">
        <SecondaryButton
          label={"戻る"}
          onClick={() => transition("/ordering-department/menu")}
        />
      </div>
    </section>
  );
};

export default OrderingDepartmentEdit;
